<template>
  <main class="flex-item">
    <div class="card mb-5">
      <header class="card-header card-title">
        <p class="card-header-title is-size-4"><span class="material-icons accent-color">person_outline</span>お問い合わせ</p>
      </header>
      <div class="card-content contractor-info">
        <label class="label mb-0">【WEBからのお問い合わせ】</label>
        <p class="mb-3"><a href="http://www.sanko-syougakutanki.co.jp/ask2.html">http://www.sanko-syougakutanki.co.jp/ask2.html</a></p>

        <label class="label mb-0">【電話でのお問い合わせ】</label>
        <p class="mb-3">0120-00-8188（受付時間：10:00～18:00）</p>

        <label class="label mb-0">【書類送付先】</label>
        <p>〒636-0002</p>
        <p>奈良県北葛城郡王寺町王寺二丁目７番１３号 山晃ビル</p>
        <p>株式会社 ＳＡＮＫＯ少額短期保険</p>
      </div>
    </div>
  </main>
</template>
